module.exports = __webpack_public_path__ + "images/FUSA_icons/052-delivery-truck-3.8244059191fbd0ac5c12f8ac48dacc34.svg";